import { CONSENT_CHANGED_EVENT } from './changeEvents'
import { useEffect, useState } from 'react'
import { isConsentRequiredOnClient } from './clientScope'
import { readConsentState } from './deviceState'
import { canUsePurpose } from './types'
import type { ConsentPurpose } from './types'
import { TRACKING_IDENTITY_PURPOSES } from '../../lib/consent/trackingIdentity'
import type { TrackingIdentity } from '../../lib/consent/trackingIdentity'

export function isWaitingForConsentDecision(): boolean {
  return isConsentRequiredOnClient() && !readConsentState()
}

export function useCanShowPostConsentPrompts(): boolean {
  const [canShow, setCanShow] = useState(false)

  useEffect(() => {
    const update = () => setCanShow(!isWaitingForConsentDecision())
    update()
    window.addEventListener(CONSENT_CHANGED_EVENT, update)
    return () => window.removeEventListener(CONSENT_CHANGED_EVENT, update)
  }, [])

  return canShow
}

export function canUseConsentPurposeOnClient(purpose: ConsentPurpose): boolean {
  if (typeof window === 'undefined') return true
  return !isConsentRequiredOnClient() || canUsePurpose(readConsentState(), purpose)
}

export function canUseTrackingIdentityOnClient(identity: TrackingIdentity = 'stitched'): boolean {
  return TRACKING_IDENTITY_PURPOSES[identity].some(canUseConsentPurposeOnClient)
}

export function canUseExperimentationOnClient(): boolean {
  return canUseConsentPurposeOnClient('experimentation') && canUseConsentPurposeOnClient('analytics')
}
